import { StakeConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

import { NumpadValidationParams } from './model';

export function validationParamsFactory(stakeConfig: StakeConfig, userService: UserService): NumpadValidationParams {
    const currency = userService.currency.toLowerCase();

    return {
        maxLeadingDigits: stakeConfig.maxLeadingDigits[currency] ? stakeConfig.maxLeadingDigits[currency] : stakeConfig.maxLeadingDigits.default,
        maxTrailingDigits: 2,
    };
}
